<template>
  <div class="app-email-i">
    <div class="ae-list-w scrollable b-r">
      <div class="ael-head">
        <div class="actions-left"></div>
        <div class="actions-right">
          <a @click="getHeaders">
            <i class="os-icon os-icon-grid-18"></i>
          </a>
          <a @click="formMode = 'add'">
            <i class="fal fa-plus"></i>
          </a>
        </div>
      </div>
      <div class="ae-list ps ps--theme_default ps--active-y users-list-w">
        <Loader v-if="loadingHeaders" />
        <div class="user-w" v-for="header in headers" v-else>
          <div class="user-avatar-w header-type">
            <div class="user-avatar">
              <div :class="mapHeaderIcon(header.header_type)"></div>
            </div>
          </div>
          <div class="user-name">
            <h6 class="user-title">{{ capitalize(header.header_name) }}</h6>
            <div class="user-role uppercase">{{ header.header_type }}</div>
          </div>
          <a class="user-action" @click="getHeaderDetails(header)">
            <div class="fal fa-eye"></div>
          </a>
        </div>
      </div>
    </div>
    <div class="ae-content-w scrollable">
      <div class="aec-head">
        <div class="actions-left" v-if="formMode == 'edit'">
          <button
            class="mr-2 mb-2 btn btn-success btn-sm"
            type="button"
            @click="updateHeader"
          >
            Update Header
          </button>
        </div>
        <div class="actions-right"></div>
      </div>
      <div
        class="ae-content"
        style="width: 100%"
        v-if="selectedHeader !== '' || formMode == 'add'"
      >
        <div
          class="aec-full-message-w"
          v-if="formMode == 'view' || formMode == 'edit'"
        >
          <div class="aec-full-message">
            <div class="message-head">
              <div class="user-w with-status">
                <div class="user-avatar-w header-type">
                  <div :class="mapHeaderIcon(selectedHeader.header_type)"></div>
                </div>
                <div class="user-name">
                  <input
                    v-if="formMode == 'edit'"
                    class="form-control"
                    name="header_name"
                    v-model="selectedHeader.header_name"
                  />
                  <h6 class="user-title" v-else @dblclick="formMode = 'edit'">
                    {{ capitalize(selectedHeader.header_name) }}
                  </h6>
                  <div class="user-role">
                    {{ selectedHeader.header_type }}
                    <!-- <span>&lt; john@solutions.com &gt;</span> -->
                  </div>
                </div>
              </div>
              <!-- <div class="message-info ">January 12th, 2017<br>1:24pm</div> -->
            </div>
            <div class="message-content property-single">
              <div class="property-info-w">
                <div class="property-info-main">
                  <div class="property-section">
                    <div
                      class="property-section-header"
                      v-show="
                        selectedHeader.default_value !== '' &&
                        selectedHeader.default_value !== null
                      "
                    >
                      Dropdown Values
                    </div>
                    <input
                      v-if="formMode == 'edit'"
                      class="form-control"
                      name="header_name"
                      v-model="selectedHeader.default_value"
                    />
                    <div
                      v-else
                      class="property-section-body"
                      v-show="
                        selectedHeader.default_value !== '' &&
                        selectedHeader.default_value !== null
                      "
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <ul>
                            <li
                              v-for="value in splitArray(
                                selectedHeader.default_value
                              )"
                            >
                              {{ value }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="property-section-header">Localization</div>
                    <div class="property-section-body">
                      <div class="table-responsive force-scrollable">
                        <table class="table table-striped table-lightborder">
                          <thead>
                            <tr>
                              <th>Locale</th>
                              <th>Display Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(value, key) in selectedHeader.languages"
                            >
                              <th>{{ key }}</th>

                              <th class="input-search-w">
                                <input
                                  v-if="formMode == 'edit'"
                                  type="text"
                                  class="form-control rounded bright"
                                  style="
                                    width: 80px;
                                    text-align: center;
                                    font-size: 15px;
                                  "
                                  v-model="selectedHeader.languages[key]"
                                />
                                <span v-else> {{ value }} </span>
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="property-section-header" v-if="selectedHeader.header_type == 'dropdown_multiple'">Values</div>
                    <div class="property-section-body" v-if="selectedHeader.header_type == 'dropdown_multiple'">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive force-scrollable ">
                            <table class="table table-striped table-lightborder">
                              <thead>
                                <tr>
                                  <th>Code</th>
                                  <th>Name En</th>
                                  <th>Name Ar</th>
                                  <th>Parent</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="x in selectedHeader.options">
                                  <th>{{ x.value_code }}</th>
                                  <th>{{ x.value_en }}</th>
                                  <th>{{ x.value_ar }}</th>
                                  <th>{{ x.value_parent }}</th>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="property-section-header">Used in templates</div>
                    <div class="property-section-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul>
                            <li
                              v-for="template in splitArray(
                                selectedHeader.template_name
                              )"
                            >
                              {{ template }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      class="property-section-header"
                      v-show="
                        selectedHeader.copy_memory !== '' &&
                        selectedHeader.copy_memory !== null
                      "
                    >
                      Copy Memory
                    </div>
                    <div
                      class="property-section-body"
                      v-show="
                        selectedHeader.copy_memory !== '' &&
                        selectedHeader.copy_memory !== null
                      "
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <ul>
                            <li
                              v-for="memory in splitArray(
                                selectedHeader.copy_memory
                              )"
                            >
                              {{ memory }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="message-attachments"></div>
            </div>
          </div>
        </div>
        <div class="element-box p-3" v-if="formMode == 'add'">
          <form id="addCopyHeader">
            <h5 class="form-header">Add New Header</h5>
            <div class="form-desc">
              You can add a new copy header, any header that you add can be used
              across multiple copy templates
            </div>

            <fieldset class="form-group">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label" for="">
                  Header Name</label
                >
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    placeholder="Header Name"
                    type="text"
                    name="header_name"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Header Type</label>
                <div class="col-sm-8">
                  <div class="form-check">
                    <label class="form-check-label"
                      ><input
                        checked=""
                        class="form-check-input"
                        name="header_type"
                        type="radio"
                        value="text"
                        v-model="addHeaderType"
                      />Text</label
                    >
                  </div>
                  <div class="form-check">
                    <label class="form-check-label"
                      ><input
                        class="form-check-input"
                        name="header_type"
                        type="radio"
                        value="textarea"
                        v-model="addHeaderType"
                      />Text Area</label
                    >
                  </div>
                  <div class="form-check">
                    <label class="form-check-label"
                      ><input
                        class="form-check-input"
                        name="header_type"
                        type="radio"
                        value="dropdown"
                        v-model="addHeaderType"
                      />Dropdown</label
                    >
                  </div>
                  <div class="form-check">
                    <label class="form-check-label"
                      ><input
                        class="form-check-input"
                        name="header_type"
                        type="radio"
                        value="dropdown_multiple"
                        v-model="addHeaderType"
                      />Dropdown Multiple</label
                    >
                  </div>
                  <div class="form-check">
                    <label class="form-check-label"
                      ><input
                        class="form-check-input"
                        name="header_type"
                        type="radio"
                        value="metric"
                        v-model="addHeaderType"
                      />Metric</label
                    >
                  </div>
                </div>
              </div>
              <div class="form-group row" v-if="addHeaderType == 'dropdown'">
                <label class="col-sm-4 col-form-label">Dropdown values</label>
                <div class="col-sm-8">
                  <textarea
                    class="form-control"
                    rows="3"
                    name="default_value"
                  ></textarea>
                </div>
              </div>
              <div
                class="form-group row"
                v-if="addHeaderType == 'dropdown_multiple'"
              >
                <label class="col-sm-4 col-form-label">Dropdown Values</label>

                <div class="col-sm-8">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label" for=""> Code</label>
                                <div class="col-sm-8"><input type="text" class="form-control" v-model="addDropdownMultipleValue.value_code"></div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label" for=""> Value (En)</label>
                                <div class="col-sm-8"><input type="text" class="form-control" v-model="addDropdownMultipleValue.value_en"></div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label" for=""> Value (Ar)</label>
                                <div class="col-sm-8"><input type="text" class="form-control" v-model="addDropdownMultipleValue.value_ar"></div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label" for=""> Parent</label>
                                <div class="col-sm-8"><input type="text" class="form-control" v-model="addDropdownMultipleValue.value_parent"></div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label" for=""> </label>
                                <button class="btn btn-primary" type="button" @click="addHeaderValue"> Add Value</button>
                            </div>
                  <div class="table-responsive force-scrollable ">
                    <table class="table table-striped table-lightborder">
                      <thead>
                        <tr>
                          <th>Code</th>
                          <th>Name En</th>
                          <th>Name Ar</th>
                          <th>Parent</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="x in addDropdownMultipleValues">
                          <th>{{ x.value_code }}</th>
                          <th>{{ x.value_en }}</th>
                          <th>{{ x.value_ar }}</th>
                          <th>{{ x.value_parent }}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </fieldset>

            <div class="form-buttons-w">
              <button class="btn btn-primary" type="button" @click="addHeader">
                Add Header
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'
import Treeselect from '@riophae/vue-treeselect'

import Loader from '@/components/common/Loader'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  mixins: [CommonFunctions],
  components: { Loader, Treeselect },

  data () {
    return {
      headers: '',
      loadingHeaders: true,
      selectedHeader: '',
      addHeaderType: 'text',
      addDropdownMultipleValue: {
        value_code: '',
        value_en: '',
        value_ar: '',
        value_parent: ''
      },
      addDropdownMultipleValues: [],
      formMode: 'view'
    }
  },

  mounted () {
    this.getHeaders()
  },

  methods: {
    getHeaders () {
      var self = this
      const url = '/copydesk/headers/'

      self.loadingHeaders = true
      this.$http
        .post(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.headers = response.data.headers
          self.loadingHeaders = false
        })
        .catch(function (error) {
          self.loadingHeaders = false
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    },

    addHeader () {
      var self = this

      const url = '/copydesk/headers/add'

      var form = document.getElementById('addCopyHeader')
      let data = new FormData(form)

      for (var i = 0; i < self.addDropdownMultipleValues.length; i++) {
        var value_data = JSON.stringify(self.addDropdownMultipleValues[i])
        data.append('header_values[]', value_data)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.getHeaderDetails(response.data.header)
          self.getHeaders()
          self.$store.dispatch('updateToast', {
            text: 'Header created',
            show: true
          })
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },

    updateHeader () {
      var self = this

      const url = '/copydesk/headers/update'

      var form = document.getElementById('editCopyHeader')
      let data = self.selectedHeader

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Header updated',
            show: true
          })
          self.formMode = 'view'
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },

    addHeaderValue () {
      var values = this.addDropdownMultipleValue
      this.addDropdownMultipleValues.push(values)
      this.addDropdownMultipleValue = {
        value_code: '',
        value_en: '',
        value_ar: '',
        value_parent: ''
      }
    },

    getHeaderDetails (header) {
      this.selectedHeader = header
      this.formMode = 'view'
    }
  }
}
</script>

<style scoped>
.form-control {
  border: none;
  padding: 0px;
  width: 260px;
  font-size: 16px;
  color: #047bf8;
  font-weight: 500;
  height: 19px;
  margin-bottom: 2px;
  border-bottom: 1px dashed #000;
}
.aec-full-message-w .message-content {
  padding: 0px;
}
.property-single .property-info-w {
  padding: 0px;
}
.property-single .property-info-w .property-info-main {
  padding: 10px;
}
.property-single .property-info-w .property-section .property-section-body {
  padding: 10px 0px;
}
.ae-content {
  padding: 0px;
}
</style>
